/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Region } from 'src/core/types/regionTypes';

export class AzureResourceGroupStore {
    public id: string;

    public name: string;

    public path: string;

    public location: Region;

    constructor(id: string, data: Partial<Omit<AzureResourceGroupStore, 'id'>>) {
        this.id = id;
        this.name = data.name;
        this.path = data.path;
        this.location = data.location;
    }
}
